import React from 'react';
import { Field, FieldArray } from 'formik';
import { List, Button, Row, Col, Space, Input, InputNumber } from 'antd';
import { PlusCircleFilled, MinusCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import classes from './Style.module.scss';
const EMPTY_SUB_PO_ITEM = [
  {
    poNo: null,
    orderQty: null,
    cartonsNo: null,
    clientName: null,
    clientPONo: null
  }
];

export default function SubPO({ name }) {
  return (
    <div className={classes.block}>
      <Field name={name}>
        {({ field }) => {
          return (
            <FieldArray
              name={name}
              render={(helper) => {
                return (
                  <List
                    className={classes.list}
                    split={false}
                    dataSource={field.value}
                    header="PO"
                    footer={
                      <Button
                        onClick={() => {
                          helper.push(EMPTY_SUB_PO_ITEM[0]);
                        }}
                        icon={<PlusCircleFilled />}
                        type="link"
                      >
                        Add New Po
                      </Button>
                    }
                    renderItem={(record, index) => {
                      return (
                        <List.Item>
                          <Row wrap gutter={[16, 16]} style={{ width: '100%' }}>
                            <Col sm={24} lg={4}>
                              <Space
                                direction="vertical"
                                className={classes.fullWidth}
                                size={4}
                              >
                                <label className={classes.fieldLabel}>
                                  Customer Name
                                </label>
                                <Field
                                  name={`${field.name}[${index}].clientName`}
                                >
                                  {({ field: inputField }) => {
                                    return <Input {...inputField} />;
                                  }}
                                </Field>
                              </Space>
                            </Col>
                            <Col sm={24} lg={5}>
                              <Space
                                direction="vertical"
                                className={classes.fullWidth}
                                size={4}
                              >
                                <label className={classes.fieldLabel}>
                                  Customer PO #
                                </label>
                                <Field
                                  name={`${field.name}[${index}].clientPONo`}
                                >
                                  {({ field: inputField }) => {
                                    return <Input {...inputField} />;
                                  }}
                                </Field>
                              </Space>
                            </Col>
                            <Col sm={24} lg={4}>
                              <Space
                                direction="vertical"
                                className={classes.fullWidth}
                                size={4}
                              >
                                <label className={classes.fieldLabel}>
                                  PO #
                                </label>
                                <Field name={`${field.name}[${index}].poNo`}>
                                  {({ field: inputField }) => {
                                    return <Input {...inputField} />;
                                  }}
                                </Field>
                              </Space>
                            </Col>
                            <Col sm={24} lg={4}>
                              <Space
                                direction="vertical"
                                className={classes.fullWidth}
                                size={4}
                              >
                                <label className={classes.fieldLabel}>
                                  Order Qty.
                                </label>
                                <Field
                                  name={`${field.name}[${index}].orderQty`}
                                >
                                  {({ field: inputField }) => {
                                    return (
                                      <InputNumber
                                        controls={false}
                                        value={inputField.value}
                                        onChange={(e) => {
                                          inputField.onChange({
                                            target: {
                                              name: inputField.name,
                                              value: e
                                            }
                                          });
                                        }}
                                      />
                                    );
                                  }}
                                </Field>
                              </Space>
                            </Col>
                            <Col sm={24} lg={4}>
                              <Space
                                direction="vertical"
                                className={classes.fullWidth}
                                size={4}
                              >
                                <label className={classes.fieldLabel}>
                                  # of Cartons
                                </label>
                                <Field
                                  name={`${field.name}[${index}].cartonsNo`}
                                >
                                  {({ field: inputField }) => {
                                    return (
                                      <InputNumber
                                        controls={false}
                                        value={inputField.value}
                                        onChange={(e) => {
                                          inputField.onChange({
                                            target: {
                                              name: inputField.name,
                                              value: e
                                            }
                                          });
                                        }}
                                      />
                                    );
                                  }}
                                </Field>
                              </Space>
                            </Col>
                            <Col lg={3} className={classes.action}>
                              <Button
                                onClick={() => {
                                  helper.remove(index);
                                }}
                                icon={<MinusCircleFilled />}
                                type="text"
                                danger
                              >
                                Remove
                              </Button>
                            </Col>
                          </Row>
                        </List.Item>
                      );
                    }}
                  />
                );
              }}
            />
          );
        }}
      </Field>
    </div>
  );
}
SubPO.propTypes = {
  name: PropTypes.string.isRequired
};
